import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminSteps from '../common/AdminSteps';
import { Row, Col, Table } from 'react-bootstrap';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as utils from '../../utils/utils';
import Spinner from 'react-spinkit';
import label from '../../utils/lngEn';
import ClassForm from './ClassForm';
import AddMeetingModal from './AddMeetingModal';
import { browserHistory } from 'react-router';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import Moment from 'moment';
import AssignmentList from './AssignmentList';
import WaitlistList from './Waitlist';

class AddDropClassPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      classLoaded: false,
      showMeetingModal: false,
      showConfirmMeetingDelete: false,
      showConfirmCourseDelete: false,
      meetingModalValues: {
        title: '',
        initialValues: {}
      },
      courseDetails: {},
      meetingDeleteId: '',
      progress: 0,
      progressMsg: '',
      progressBar: 0,
      isFetchingStudent: false,

      assignments: [],
      waitlists: []
    };

    this.handleClassFormSubmit = this.handleClassFormSubmit.bind(this);
    this.openAddMeetingModal = this.openAddMeetingModal.bind(this);
    this.openEditMeetingModal = this.openEditMeetingModal.bind(this);
    this.closeMeetingModal = this.closeMeetingModal.bind(this);
    this.closeDeleteMeetingModal = this.closeDeleteMeetingModal.bind(this);
    this.handleDeleteMeeting = this.handleDeleteMeeting.bind(this);
    this.openDeleteMeetingModal = this.openDeleteMeetingModal.bind(this);
    this.closeDeleteCourseModal = this.closeDeleteCourseModal.bind(this);
    this.openDeleteCourseModal = this.openDeleteCourseModal.bind(this);
    this.handleDeleteCourse = this.handleDeleteCourse.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.updateAssignmentList = this.updateAssignmentList.bind(this);
    this.updateWaitlistList = this.updateWaitlistList.bind(this);
  }

  async componentDidMount() {
    const { run, studentActions, students, runActions, classId, courseActions, course } = this.props;
    if (!run.id) {
      runActions.getRun();
    }

    if (classId) {
      this.setState({ classLoaded: false });
     courseActions.getCourseById(classId).then(() => {
       courseActions.getAssignmentlist(classId).then((res) => {
          this.setState({ assignments: res.results });
        });
       courseActions.getWaitlistlist(classId).then((res) => {
          this.setState({ waitlists: res.results });
        });
        this.setState({ courseDetails: course, classLoaded: true });
      });
      this.setProgress(course);
    }
    if (students.length <= 0) {
      this.setState({ isFetchingStudent: true });
      await studentActions.getAllStudents();
      this.setState({ isFetchingStudent: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.course.id || nextProps.course != this.props.course) {
      this.setProgress(nextProps.course);
      this.setState({ courseDetails: nextProps.course, classLoaded: true });
    }
  }

  setProgress = (course) => {

    let progress = ((course.assigned_students * 100) / course.target_capacity).toFixed(0);
    let msg = course.assigned_students > 0 ? course.assigned_students + ' assignments' : 'No assignments yet';
    let progressBar = progress * 0.83333;
    if (progressBar > 100) {
      progressBar = 100;
    }
    this.setState({ progressBar });
    this.setState({ progressMsg: msg });
    if (!isNaN(progress)) {
      this.setState({ progress: progress });
    }
  }

  handleClassFormSubmit(values) {
    if (values.id) {
      this.props.courseActions.putCourse(values).then(() => {
        this.props.courseActions.getCourseById(this.props.classId);
        this.props.courseActions.getAllCourses();
      });
    } else {
      this.props.courseActions.createCourse(values).then(res => {
        this.props.courseActions.getCourseById(res.id);
        this.props.courseActions.getAllCourses();
        browserHistory.push('/administer/' + localStorage.getItem('run') + '/class/' + res.id);
      });
    }
  }

  // Meeting Modal
  openAddMeetingModal() {
    this.setState({
      showMeetingModal: true,
      meetingModalValues: {
        title: `${label.createMeeting}`,
        classId: this.props.classId,
        initialValues: {}
      }
    });
  }
  openEditMeetingModal(m) {
    this.setState({
      showMeetingModal: true,
      meetingModalValues: {
        title: `${label.editMeeting}`,
        classId: this.props.classId,
        initialValues: {
          id: m.id,
          day: m.day.toString(),
          location: m.location,
          startdate: m.startdate,
          enddate: m.enddate,
          starttime: m.starttime,
          endtime: m.endtime
        }
      }
    });
  }
  closeMeetingModal() {
    this.setState({ showMeetingModal: false });
  }

  // Delete Class
  openDeleteCourseModal() {
    this.setState({ showConfirmCourseDelete: true });
  }
  handleDeleteCourse() {
    this.props.courseActions.deleteCourse(this.props.classId).then(() => {
      this.props.courseActions.getAllCourses();
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/classes');
    });
  }
  closeDeleteCourseModal() {
    this.setState({ showConfirmCourseDelete: false });
  }
  // Delete Meeting
  openDeleteMeetingModal(id) {
    this.setState({
      showConfirmMeetingDelete: true,
      meetingDeleteId: id
    });
  }
  handleDeleteMeeting() {
    if (this.state.meetingDeleteId != '') {
      this.props.courseActions.deleteMeeting(this.props.course.id, this.state.meetingDeleteId).then(() => {
        this.props.courseActions.getCourseById(this.props.classId);
        this.closeDeleteMeetingModal();
      });
    }
  }

  closeDeleteMeetingModal() {
    this.setState({ showConfirmMeetingDelete: false });
  }

  updateAssignmentList() {
    this.props.courseActions.getAssignmentlist(this.props.course.id).then((res) => {
      this.setState({ assignments: res.results });
    });
  }

  updateWaitlistList() {
    this.props.courseActions.getWaitlistlist(this.props.course.id).then((res) => {
      this.setState({ waitlists: res.results });
    });
  }

  formatDate(date) {
    if (date) {
      return Moment(date).format('MM/DD/YYYY');
    } else {
      return '-';
    }
  }
  render() {
    const { isFetchingStudent, progressBar, assignments, waitlists } = this.state;
    const { course, students, run, children: AccessRulesSection } = this.props;
    const { waitlisted_students } = course;
    const { assignment_complete, slug: runSlug } = run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Class</div>

        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete} />
        {this.props.classId ? (
          <button
            className="btn btn-ter pull-right delete-course"
            onClick={() => {
              this.openDeleteCourseModal();
            }}
          >
            Delete Class
          </button>
        ) : null}
        <Row>
          <Col md={8}>
            {(this.props.classId && this.state.courseDetails.id) || !this.props.classId ? (
              <div>
                {this.props.classId ? (
                  <div className="page-subtitle">
                    <span className="sub-title-gray mr-2">{label.class}</span>
                    {this.props.course.slug}
                  </div>
                ) : (
                  <div className="page-subtitle">Create New Class</div>
                )}

                {this.props.classId && this.props.course.id && this.state.classLoaded ? (
                  <ClassForm onSubmit={this.handleClassFormSubmit} initialValues={this.state.courseDetails} assignment_complete={assignment_complete} />
                ) : !this.props.classId && !this.state.classLoaded ? (
                  <ClassForm onSubmit={this.handleClassFormSubmit} initialValues={this.state.courseDetails} assignment_complete={assignment_complete} />
                ) : null}
                <AssignmentList
                    course={course}
                    items={assignments}
                    isLoading={isFetchingStudent}
                    students={students}
                    courseActions={this.props.courseActions}
                    runSlug={runSlug}
                    updateAssignmentList={this.updateAssignmentList}
                />
                <WaitlistList
                  course={course}
                  items={waitlists}
                  isLoading={isFetchingStudent}
                  students={students}
                  courseActions={this.props.courseActions}
                  runSlug={runSlug}
                  updateWaitlistList={this.updateWaitlistList}
                />
                {this.props.classId ? (
                  <div>
                    <div className="page-subtitle">Meetings</div>
                    <Row className="mb-2 mt-n-2">
                      <Col md={12}>
                        <button
                          onClick={() => {
                            this.openAddMeetingModal();
                          }}
                          className="btn btn-ter"
                        >
                          {label.addMeeting}
                        </button>
                      </Col>
                    </Row>

                    {this.props.course.meetings.length > 0 ? (
                      <div className="c-table classes-table mt-2">
                        <Table condensed hover>
                          <thead>
                            <tr>
                              <th>Day</th>
                              <th>Location</th>
                              <th>Start Date</th>
                              <th>Start Time</th>
                              <th>End Date</th>
                              <th>End Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.course.meetings.map((meeting, index) => {
                              return (
                                <tr key={index}>
                                  <td className="class-desc">{utils.convertDay(meeting.day)}</td>
                                  <td className="class-desc">{meeting.location}</td>
                                  <td className="class-desc">{this.formatDate(meeting.startdate)}</td>
                                  <td className="class-desc">{meeting.starttime}</td>
                                  <td className="class-desc">{this.formatDate(meeting.enddate)}</td>
                                  <td className="class-desc">{meeting.endtime}</td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openEditMeetingModal(meeting);
                                      }}
                                      className="fa fa-pencil"
                                    />
                                  </td>
                                  <td className="class-desc">
                                    <i
                                      onClick={() => {
                                        this.openDeleteMeetingModal(meeting.id);
                                      }}
                                      className="fa fa-trash"
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    ) : null}

                    {AccessRulesSection}
                    {this.props.courses.length > 0 ? (
                      <div>
                        <AddMeetingModal
                          closeModal={this.closeMeetingModal}
                          showModal={this.state.showMeetingModal}
                          onCancel={this.closeMeetingModal}
                          initial={this.state.meetingModalValues}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : (
              <Spinner spinnerName="three-bounce" />
            )}
          </Col>
          <Col md={4}>
            {this.props.classId && this.state.classLoaded ? (
              <div className="sidebar-container">
                <div className="sidebar-header">Add/Drop Session Status</div>
                <div className="progress-box mt-4">
                  {this.state.progressMsg}
                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ width: progressBar + '%' }}
                    />
                  </div>
                  <div
                    className="relative class-progress-bar"
                    style={{
                      width: 83.33 + '%',
                      backgroundColor: 'rgba(80,80,80,0.2)',
                      height: '20px',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px',
                      top: '-25px'
                    }}
                  >
                    <i className="fa fa-caret-up progress-bar-arrow" />
                    <span className="progress-bar-arrow-percentage">100%</span>
                  </div>
                  <p>{this.state.progress + '% of capacity'}</p>
                  <p>{waitlisted_students} on waitlist</p>
                </div>
              </div>
            ) : null}
          </Col>
        </Row>
        <ConfirmDeleteModal
          closeModal={this.closeDeleteMeetingModal}
          showModal={this.state.showConfirmMeetingDelete}
          onCancel={this.closeDeleteMeetingModal}
          customMsg={label.deleteMeetingCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteMeeting}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteCourseModal}
          showModal={this.state.showConfirmCourseDelete}
          onCancel={this.closeDeleteCourseModal}
          customMsg={label.deleteCourseCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteCourse}
        />
      </Col>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let classId = null;
  if (ownProps.params.id) {
    classId = ownProps.params.id;
  }
  return {
    run: state.run,
    courses: state.courses,
    waitlists: state.waitlists,
    assignments: state.assignments,
    course: state.course,
    classId: classId,
    students: state.students
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDropClassPage);



// WEBPACK FOOTER //
// ./src/components/classes/AddDropClassPage.js